import { connect } from 'react-redux';

import { notificationsMessagesSeenAction } from '../actions/notificationMessageAction';
import {
  getNotificationsMessageSeenSelectors,
  getNotificationsMessageUnreadSelectors,
} from '../components/NotificationMessage/NotificationMessageSelectors';
import Notifications from '../components/NotificationMessage/NotificationsView';

const mapStateToProps = (state) => ({
  notificationsUnread: getNotificationsMessageUnreadSelectors(state),
  notificationsRead: getNotificationsMessageSeenSelectors(state),
});

const mapDispatchToProps = (dispatch) => ({
  notificationsMessagesSeen: (notifications) =>
    dispatch(notificationsMessagesSeenAction(notifications)),
});

const NotificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notifications);

export default NotificationsContainer;
